<div class="d-flex align-items-center montserrat justify-content-center pb-kh-5 responsive">
  <div class="text-center info-box-size">
      <kh-info-box class="info-box-size">
          <div class="d-flex flex-column text-center">
              <div class="kh-text-secondary kh-body-md pb-kh-2">
                  {{targetDisplayName}}
              </div>
              <div class="kh-text-primary kh-title-lg">
                  {{targetEmail}} 
              </div>
          </div>
      </kh-info-box>
      <div class="kh-text-error kh-caption-sm mt-kh-3">
          {{ 'MERGE_ACCOUNT_PREVIEW.THIS_ACCOUNT_WILL_BE_DELETED' | translate }}
      </div>

  </div>

  <div class="px-kh-5 arrow-mobile">
      <svg class="icon-size" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.83 21.11"><path d="M15.71.88c-1-1.1-2.7-1.2-3.8-.1-1.1,1-1.2,2.7-.1,3.8l3.2,3.3H2.81C1.31,7.88.11,8.98,0,10.38c-.1,1.7,1.1,2.9,2.7,2.9h12.3l-3.1,3.3c-1,1.1-1,2.7.1,3.8,1.1,1,2.7,1,3.8-.1l7.2-7.8c1.1-1.2,1.1-2.9,0-4L15.71.88Z" fill="#333d4d" stroke-width="0"></path></svg>
  </div>
  <div class="text-center info-box-size">
      <kh-info-box class="info-box-size">
          <div class="d-flex flex-column text-center">
              <div class="kh-text-secondary kh-body-md pb-kh-2">
                  {{ sourceDisplayName }}
              </div>
              <div class="kh-text-primary kh-title-lg">
                  {{sourceEmail}}
              </div>
          </div>
      </kh-info-box>
      <div class="kh-text-primary kh-caption-sm mt-kh-3">
          {{ 'MERGE_ACCOUNT_PREVIEW.THIS_ACCOUNT_WILL_BE_PRESERVED' | translate }}
      </div>
  </div>
</div>